export default __webpack_public_path__ + "static/media/ANUENCIA_MUNICIPAL_PARA_COMITES_2024.1bebe7f8.pdf";